(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', '../colors'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('../colors'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.colors);
    global.getVariantFromProps = mod.exports;
  }
})(this, function (exports, _colors) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = getVariantFromProps;

  var _colors2 = _interopRequireDefault(_colors);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function getVariantFromProps(props) {
    if (props.light) return { color: _colors2.default.white };
    if (props.muted) return { color: _colors2.default.slate };
    if (props.link) {
      return {
        color: _colors2.default.jungle,
        '& > a': {
          color: _colors2.default.jungle,
          textDecoration: 'none'
        },
        '&:hover': {
          color: _colors2.default.mint600,
          textDecoration: 'none'
        },
        '&:hover > a': {
          color: _colors2.default.mint600,
          textDecoration: 'none'
        }
      };
    }
    if (props.bold) return {
      fontWeight: 700
    };
  }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/styles/typography/getVariantFromProps.js
// module id = 824
// module chunks = 1